<template>
  <div class="splash">
    <div class="labs-loader" v-if="loading"></div>
    <div class="logo-block">
      <span class="icon-folder-settings"></span>
      <h1>Refinitiv Trade Discovery</h1>
    </div>
    <button class="button button-outline splash-button button-medium" @click="signIn()">
      Sign in
    </button>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
// declare var AuthBar: any;

import Env from '@/services/env.service';
import gaService from '../services/ga.service';

@Component({
  components: {
  },
})
export default class Splash extends Vue {
  public loading: boolean = true;

  get environment() {
    return Env.get('VUE_APP_ENVIRONMENT');
  }

   get isPingAUth() {
    return Env.get('APP_AUTH_PING');
  }


  get authToken() {
    return this.$store.state.auth.authToken;
  }


  get user() {
    return this.$store.state.auth.user;
  }

  public showSignIn() {
    this.$store.commit('setModal', 'auth_signInEmail');
  }

  public showNoCompany() {
       this.$store.commit('setModal', 'noCompany');
  }

  // @Watch('authToken')
  // private onPropertyChanged(value: string, oldValue: string) {
  //   if (value && !oldValue) {
  //     this.checkForCompanyParam();
  //     this.$router.push('/');
  //   }
  // }

  @Watch('user')
  private onPropertyChanged(value: string, oldValue: string) {
    if (value && !oldValue) {
      // this.checkForCompanyParam();
      this.$router.push('/');
    }
  }

  public checkForCompanyParam() {
    let companyName = 'Test Manual';
    if (this.$route.query.company && typeof this.$route.query.company === 'string') {
      companyName = this.$route.query.company;
    }
    gaService.setDimension(this.$gtag, 'dimension1', companyName);

  }

  private signIn() { 
    console.log(Env.get("VUE_APP_AUTH_BACK_URL") + "/login");
    location.href = Env.get("VUE_APP_AUTH_BACK_URL") + "/login";
  }

  private onLogin(tokens: any[]) {
    const siteTokens = tokens.find((t: any) => t.dst === Env.get('VUE_APP_ISSUER'));
    this.$store.dispatch('onLogin', {
      token: siteTokens.token,
      exp: siteTokens.exp || 0
    });

    // GAService.setDimension(this.$gtag, 'user_id', siteTokens.sub);

    // this.listenForFocus();
  }



  private async login(){
    // const codeVerifier = generateCodeVerifier(64);
    // var codeChallenge = ''; 
    // const challengeMethod = crypto.subtle ? "S256" : "plain"
    // if (challengeMethod === 'S256') {
    //     codeChallenge = await generateCodeChallange(codeVerifier);
    // } else {
    //     codeChallenge = codeVerifier
    // }
    // localStorage.setItem('pkce_code_verfier', codeVerifier);

    // const params = new URLSearchParams({
    //   response_type: 'code',
    //   client_id: '1854c166-225e-4f3c-b5d5-b370b3541111',
    //   redirect_uri: 'https://tradediscovery-appback.aws-3-qa-staging-frtb.public.inf0.net/login/invite',
    //   // scope: 'trapi',
    //   code_challenge: codeChallenge,
    //   code_challenge_method: 'S256',
    //   // state: ''
    // });

    // window.location.href = `https://login.stage.ciam.refinitiv.com/as/authorization.oauth2?${params}`;  


  }
   

  private mounted() {
    this.$store.commit('setLoading', false);
    if (this.$route.meta && this.$route.meta.fromAuth) {
      // This (should) mean we have come to this componet via /auth, ie from the admin frontend
      // redirect. We want to see if we already have an auth token, ie has authbar slurped the 
      // admin's url param and given us an auth token already?

    
      if (this.user) {
        // this.checkForCompanyParam();

        this.$router.push('/');
      } else {
        // If we don't alreayd have auth lib's auth token, we wait for the authToken
        // property to change (see above). This will then handle redirection when received.
        this.loading = false;
      }

    }else  if(this.$route.query.unauthorized === 'true' && this.$route.query.fromSplash === 'true'){
      this.showNoCompany();
    } else {
          this.showSignIn()

    }
  }
  
}
</script>
<style lang="scss">
  .splash {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 100vh;
    max-height: 100vh !important;
    width: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url('./../assets/splash_bg.jpg');
    color: white;
    padding: 0 40px;

    .logo-block {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      span {
        color: #fff;
        font-size: 70px;
      }

      h1 {
        font-size: 56px;
        line-height: 1.2em;
        margin-top: 40px;
        font-weight: 700;
      }
    }

    .splash-description {
      font-size: 20px;
      margin-top: 25px;
      max-width: 600px;
    }

    .splash-button {
      margin-top: 40px;
    }

    .employee-link {
      margin-top: 30px;
      text-decoration: underline;

      &:hover {
        cursor: pointer;
        opacity: .8;
      }
    }
  }
</style>